import { render } from "./headerVue.vue?vue&type=template&id=ba6b4d90"
import script from "./headerVue.vue?vue&type=script&lang=js"
export * from "./headerVue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__